import React from 'react'
import * as R from 'remeda'

import {
  AnswerOptionConditionalSelector,
  type AnswerOptionConditionalSelectorProps,
} from '~/components/features/AnswerOptionConditionalSelector'
import { type ConditionOperation } from '~/gql/graphql'
import { intersectionBy } from '~/utils'

import { type AnswerOption } from '../utils'

export type AnswerOptionsInputProps = {
  answerOptions: AnswerOption[]
  conditionOperation: ConditionOperation
  value: AnswerOption[]
  onBlur: () => void
  onChange: (value: AnswerOption[]) => void
}

export const AnswerOptionsInput = React.forwardRef<
  HTMLDivElement,
  AnswerOptionsInputProps
>(({ answerOptions, conditionOperation, onBlur, onChange, value }, ref) => {
  const handleChange = React.useCallback<
    EH<AnswerOptionConditionalSelectorProps<AnswerOption>, 'onChange'>
  >(
    (options) => {
      onChange(
        intersectionBy(answerOptions, options, R.prop('option'), R.identity()),
      )
    },
    [answerOptions, onChange],
  )

  return (
    <AnswerOptionConditionalSelector
      ref={ref}
      answerOptions={answerOptions}
      conditionOperation={conditionOperation}
      value={value.map(R.prop('option'))}
      onBlur={onBlur}
      onChange={handleChange}
    />
  )
})
